import * as React from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import MRMLogo from "@/assets/images/LogoMRM-HD.png";
import { NavMain } from "./ui/nav-main";
import NavUser from "./ui/nav-user";
import { NavSecondary } from "./ui/nav-secondary";
import { useSelector } from "react-redux";
import { userSelector } from "@/redux/user/user.selector";
import { CenteredLoader } from "@/components/ui/loading";

const AppSidebar = ({ ...props }: React.ComponentProps<typeof Sidebar>) => {
  const { userInfo } = useSelector(userSelector).ui;
  return (
    <>
      {userInfo ? (
        <Sidebar collapsible="offcanvas" {...props} className="min-h-[30rem]">
          <SidebarHeader className="border-sidebar-border h-14 border-b">
            <SidebarMenu>
              <SidebarMenuItem className="px-2">
                <div className="flex flex-row justify-start items-center gap-2 w-full">
                  <img alt="logo" src={MRMLogo} className="w-[1.5rem]" />
                  <span className="text-[14px] font-[Inter] font-semibold">
                    Murillo Rufinelli Moreira
                  </span>
                </div>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarHeader>
          <SidebarContent>
            <NavMain />
          </SidebarContent>
          <SidebarFooter>
            <NavSecondary className="mt-auto px-2" />
            <NavUser userInfo={userInfo} />
          </SidebarFooter>
        </Sidebar>
      ) : (
        <div className="w-64 h-screen bg-sidebar border-r">
          <CenteredLoader message="Iniciando sesión..." />
        </div>
      )}
    </>
  );
};

export default AppSidebar;
